(() => {
  function donateExpansion() {
    const donateButton = document.getElementById('donate-button');
    const donateContainer = document.getElementById('donate-container');
    if (!donateButton || !donateContainer) return;

    const donateContainerTl = gsap.timeline({
      paused: true,
    })
      .fromTo(donateContainer, {
        display: 'none',
      }, {
        display: 'flex',
        duration: 0.01,
      })
      .fromTo(donateContainer, {
        height: '0',
        opacity: '0',
      }, {
        height: 'auto',
        opacity: '1',
        duration: 0.5,
      });

    function toggleDonateContainer() {
      const isOpen = donateButton.getAttribute('aria-pressed') === 'true';

      donateButton.setAttribute('aria-hidden', !isOpen);
      donateButton.setAttribute('aria-pressed', !isOpen);

      if (isOpen) {
        donateContainerTl.reverse();
      } else {
        donateContainerTl.play();
      }
    }

    donateButton.addEventListener('click', toggleDonateContainer);
  }

  function init() {
    donateExpansion();
  }
  document.addEventListener('DOMContentLoaded', init, false);
})();
